import modelEnhance from "@/utils/modelEnhance";
import http from "../http/index"
import { downExcel, serviceKey } from "@/utils/constant";

const tokiot = http.tokiot
export default modelEnhance({
    namespace: "store",
    state: {
        mode: false,
    },
    subscriptions: {},
    effects: {
        * changeMode({ payload = {} }, { call, put, select }) {
            const { mode = true } = payload
            yield put({ type: "commonSuccess", payload: { mode } });
        }
    },
    reducers: {
        commonSuccess(state, { payload }) {
            return { ...state, ...payload };
        }
    }
});
